/** Rollen- bzw. Rank-Farben nach CSS übersetzen. */

const NAMED_COLORS: Record<string, string> = {
  black: '#1e293b',
  dark_blue: '#1d4ed8',
  dark_gray: '#475569',
  dark_green: '#15803d',
  dark_purple: '#7c3aed',
  dark_red: '#b91c1c',
  dark_aqua: '#0e7490',
  blue: '#3b82f6',
  gold: '#f59e0b',
  gray: '#94a3b8',
  green: '#22c55e',
  aqua: '#22d3ee',
  red: '#ef4444',
  light_purple: '#c084fc',
  yellow: '#facc15',
  white: '#f8fafc',
  orange: '#fb923c',
  pink: '#f472b6',
};

export const FALLBACK_COLOR = '#64748b';

/**
 * Akzeptiert `#rrggbb`, MiniMessage-Tags (`<red>`) und einfache Farbnamen.
 * Alles Unbekannte fällt auf einen neutralen Grauton zurück.
 */
export function cssColor(raw: string | null | undefined, fallback: string = FALLBACK_COLOR): string {
  if (raw === null || raw === undefined) return fallback;
  const value = raw.trim();
  if (value === '') return fallback;
  if (/^#[0-9a-f]{3}$|^#[0-9a-f]{6}$|^#[0-9a-f]{8}$/i.test(value)) return value;

  const lower = value.toLowerCase();
  const tagged = /^<([a-z_]+)>$/.exec(lower);
  const name = tagged?.[1] ?? lower;
  return NAMED_COLORS[name] ?? fallback;
}
